import {Component, OnInit, Inject} from '@angular/core';
import {ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ConfirmComponent} from '../../../shared/dialogs/confirm/confirm.component';
import {PushSponsorService} from '../../../services/push-sponsor.service';
import {AuthService} from '../../../services/auth.service';
import {PushSponsor} from '../../../models/push-sponsor';
import {SnackBarIconService} from '../../../shared/snack-bar-icon/snack-bar-icon.service';
import {SponsorService} from 'src/app/services/sponsor.service';
import {Sponsor} from 'src/app/models/sponsor';
//import {firestore} from 'firebase/app';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
    isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'app-push-sponsor-dialog',
    templateUrl: './push-sponsor-dialog.component.html',
    styleUrls: ['./push-sponsor-dialog.component.scss'],
    entryComponents: [
        ConfirmComponent
    ],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
    ]
})
export class PushSponsorDialogComponent implements OnInit {

    public matcher = new FormErrorStateMatcher();
    public entityForm: FormGroup;
    public current_push: PushSponsor;

    public isEdit: boolean;
    public allSponsors: any[] = []

    public displayedListColumns: string[] = ['icon', 'name', 'delete'];

    constructor (
        private fb: FormBuilder,
        private dialog: MatDialog,
        public _pushSponsorService: PushSponsorService,
        public _sponsorService: SponsorService,
        private _authService: AuthService,
        private snackBar: SnackBarIconService,
        private _adapter: DateAdapter<any>,
        @Inject(MAT_DIALOG_DATA) public data: PushSponsor
    ) {

        this.current_push = this.data;
        this.loadSponsors();

    }

    ngOnInit () {

        this._adapter.setLocale('pt');
        // check is is insert or update
        this.isEdit = this.data.id != "0"
        // create user form
        this.entityForm = this.createForm()
        // populate the form
        this.setFormValues(this.data, this.entityForm)
    }

    insert () {

        if (this.entityForm.valid) {
            this._pushSponsorService.spinner = true;
            let push: PushSponsor = this.createPush(this.entityForm.value);

            this._pushSponsorService.insert(push)
                .then((result) => {
                    this.data.id = result.id
                    this.isEdit = true;
                    this.entityForm.controls.id.setValue(result.id);
                    this.snackBar.openSnackBar('Sucesso!', '', 'success');
                })
                .catch((error) => {
                    console.log("insert push error: " + error)
                    this.snackBar.openSnackBar(error.details.code, '', 'error');
                })
                .finally(() => {
                    this._pushSponsorService.spinner = false
                });

        }

    }

    update () {

        if (this.entityForm.valid) {
            this._pushSponsorService.spinner = true;
            let push: PushSponsor = this.createPush(this.entityForm.value);

            this._pushSponsorService.update(push)
                .then(() => {
                    this.snackBar.openSnackBar("Sucesso!", '', 'success');
                })
                .catch((error) => {
                    console.log("push update error: " + JSON.stringify(error))
                    this.snackBar.openSnackBar(error.details.code, '', 'error');
                })
                .finally(() => {
                    this._pushSponsorService.spinner = false
                });

        }
    }

    createPush (data: any): PushSponsor {


        let sponsor = this.allSponsors.find((e) => {
            return e.id == data.sponsor_id
        })

        let push: any = {}
        push.id = data.id;

        push.sponsor_id = sponsor.id
        push.sponsor_name = sponsor.name;

        push.title = data.title;
        push.text = data.text;
        push.url = data.url;

        push.date_create = new Date(); //firestore.FieldValue.serverTimestamp();
        push.sent = data.sent ? data.sent : false;

        let dd = new Date(data.date_send).getDate()
        let mm = new Date(data.date_send).getMonth()
        let yy = new Date(data.date_send).getFullYear()

        let parts = data.time_send.split(":")

        let hora = parts[0]
        let min = parts[1]

        push.date_send = new Date(
            Number(yy),
            Number(mm),
            Number(dd),
            Number(hora),
            Number(min)
        )

        push.time_send = data.time_send;

        return push;
    }

    setFormValues (data, form) {

        form.controls.id.setValue(data.id);

        form.controls.sponsor_id.setValue(data.sponsor_id);

        form.controls.title.setValue(data.title);
        form.controls.text.setValue(data.text);
        form.controls.url.setValue(data.url);

        form.controls.sent.setValue(data.sent);

        if (data.date_create) {
            let dt: any = data.date_create
            form.controls.date_create.setValue(new Date(dt.seconds * 1000));
        }

        if (data.date_send) {
            let dt: any = data.date_send
            form.controls.date_send.setValue(new Date(dt.seconds * 1000))
        }

        form.controls.time_send.setValue(data.time_send);

    }

    createForm () {

        let form: FormGroup = this.fb.group({
            id: new FormControl(''),
            sponsor_id: new FormControl('', [Validators.required]),
            title: new FormControl('', [Validators.required]),
            text: new FormControl('', [Validators.required]),
            url: new FormControl(''),
            date_create: new FormControl(''),
            date_send: new FormControl('', [Validators.required]),
            time_send: new FormControl('', [Validators.required]),
            sent: new FormControl(''),

        });
        return form
    }

    loadSponsors () {

        this._sponsorService.select()
            .subscribe((result) => {

                this.allSponsors = result.map(item => {
                    let entity = new Sponsor();
                    entity.id = item.payload.doc.id;
                    entity.name = item.payload.doc.data().name;
                    entity.url = item.payload.doc.data().url;
                    entity.image = item.payload.doc.data().image;

                    return entity;
                });


            },
                (error) => {
                    console.log(JSON.stringify(error))
                    this.snackBar.openSnackBar("Acesso negado", '', 'error');
                })

    }


}



